import React from 'react';

// Only what every pupil gets, whatever their instructor uses: nothing that
// suggests how lessons should be taught or run
const FEATURES = [
    {
        icon: 'calendar',
        title: 'Your next lesson',
        text: 'See when and where your next lesson is at a glance.',
    },
    {
        icon: 'list',
        title: 'All your lessons',
        text: 'Look back at past lessons and see everything coming up.',
    },
    {
        icon: 'comments',
        title: 'Contact your instructor',
        text: 'Call or message your instructor straight from the app.',
    },
    {
        icon: 'bell',
        title: 'Lesson updates',
        text: 'Know straight away when a lesson is booked, moved or cancelled.',
    },
    {
        icon: 'car',
        title: 'Your driving test',
        text: 'Keep your test date, time and centre to hand.',
    },
    {
        icon: 'shield-halved',
        title: 'Your details and data',
        text: 'Keep your details up to date, and see the information your school holds about you.',
    },
];
const ICON_STYLES = ['', 'item-2', 'item-3', 'item-4'];

function FeaturesPupilApp() {
    return (
        <section className="dd-service-area dd-pupil-features pt-90 pb-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-7">
                        <div className="dd-section-title text-center">
                            <h3 className="dd-title">Everything about your lessons, in your pocket</h3>
                            <p>Your instructor can share more with you in the app too.</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {FEATURES.map((feature, index) => (
                        <div className="col-lg-4 col-md-6" key={feature.title}>
                            <div
                                className={`dd-single-service text-center mt-30 ${
                                    ICON_STYLES[index % ICON_STYLES.length]
                                }`}
                            >
                                <div className="icon">
                                    <i className={`fa-jelly-fill fa-regular fa-${feature.icon}`} />
                                </div>
                                <h4 className="dd-title">{feature.title}</h4>
                                <p>{feature.text}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default FeaturesPupilApp;
